var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-input", {
        attrs: { placeholder: "点击选择主诉" },
        on: { focus: _vm.initData },
        model: {
          value: _vm.content,
          callback: function ($$v) {
            _vm.content = $$v
          },
          expression: "content",
        },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "chief-complaint-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            title: "主诉选择",
            width: "1000px",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.confirmSelection },
                    },
                    [_vm._v("确定（Ctrl+Enter）")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "fixed-header" }, [
            _c(
              "div",
              { staticClass: "search-container" },
              [
                _c("el-input", {
                  ref: "searchInput",
                  attrs: {
                    placeholder: "请输入关键词搜索 (Ctrl+F 聚焦)",
                    "prefix-icon": "el-icon-search",
                    clearable: "",
                  },
                  on: { input: _vm.handleSearch },
                  nativeOn: {
                    keydown: function ($event) {
                      return _vm.handleSearchKeydown.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.searchKeyword,
                    callback: function ($$v) {
                      _vm.searchKeyword = $$v
                    },
                    expression: "searchKeyword",
                  },
                }),
              ],
              1
            ),
            _vm.selectedItems.length > 0
              ? _c("div", { staticClass: "selected-container" }, [
                  _c("div", { staticClass: "selected-label" }, [
                    _vm._v("已选中："),
                  ]),
                  _c(
                    "div",
                    { staticClass: "selected-items" },
                    _vm._l(_vm.selectedItems, function (item, idx) {
                      return _c(
                        "el-tag",
                        {
                          key: "selected-" + idx,
                          attrs: { closable: "" },
                          on: {
                            close: function ($event) {
                              return _vm.removeSelected(item.id)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(item.name) + " ")]
                      )
                    }),
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "chief-complaint-container" }, [
            _c(
              "div",
              {
                ref: "treeContainer",
                staticClass: "tree-container",
                class: { "focus-area": _vm.focusArea === "tree" },
                attrs: { tabindex: "-1" },
              },
              [
                _c("el-tree", {
                  ref: "tree",
                  attrs: {
                    data: _vm.treeData,
                    props: _vm.treeProps,
                    "expand-on-click-node": false,
                    "default-expand-all": "",
                    "node-key": "id",
                    "highlight-current": "",
                  },
                  on: { "node-click": _vm.handleNodeClick },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                ref: "listContainer",
                staticClass: "list-container",
                class: { "focus-area": _vm.focusArea === "list" },
                attrs: { tabindex: "-1" },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticClass:
                      "keyword-con flex flex-row align-start items-wrap",
                  },
                  [
                    _vm._l(_vm.filteredItems, function (item, index) {
                      return _c(
                        "span",
                        {
                          key: item.id,
                          staticClass: "keyword cursor-pointer",
                          class: {
                            selected: _vm.isSelected(item),
                            highlighted: index === _vm.highlightedIndex,
                          },
                          style: _vm.keywordStyle,
                          on: {
                            click: function ($event) {
                              return _vm.toggleSelect(item)
                            },
                          },
                        },
                        [
                          _vm._v(" " + _vm._s(item.name) + " "),
                          _vm.isSelected(item)
                            ? _c("i", {
                                staticClass: "el-icon-check selected-icon",
                              })
                            : _vm._e(),
                        ]
                      )
                    }),
                    _vm.filteredItems.length === 0 && !_vm.loading
                      ? _c("div", { staticClass: "empty-text" }, [
                          _vm._v(" 暂无数据 "),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }